import $ from 'jquery';
import ScrollSpy from 'bootstrap/js/src/scrollspy';
import {lazyInitByScroll, onViewportEnter} from '../helpers/lazyInit';
import {loadArrangementListMainContent} from '../helpers/arrangementListPageHelpers';
import {handlePageView} from '../helpers/pageViewHelpers';
import GalleryWithPreview from './GalleryWithPreview';
import CustomSeasonEndPopUp from './newsletter/CustomSeasonEndPopUp';
import RecentlyViewedItems from './RecentlyViewedItems';
import RichContentReviews from './RichContentReviews';
import {initVBTHomepageAboveTheFoldTest} from '../helpers/abTestHelpers';

const DURATION = 500;

class EventPageContent {
	constructor(params) {
		this.params = params;
		this.richContentReviews = this._createRichContentReviews();

		this.init();
	}

	init() {
		handlePageView({
			'saveUrl' : `user/viewed/event/${this.getCurrentEventId()}/`,
			'fetchUrl': `viewed/event/${this.getCurrentEventId()}/`
		});
		new GalleryWithPreview();

		requestAnimationFrame(() => {
			this.saveViewedEvent();
			this.initTracking();
			this.initArrangementsList();

			requestAnimationFrame(() => {
				this.initEvents();

				if (window.CustomSeasonEndPopUp && window.CustomSeasonEndPopUp.shouldShow) {
					new CustomSeasonEndPopUp();
				}
			});
			lazyInitByScroll(this.initScrollspy.bind(this));
		});

		const reviewsBlock = document.querySelector('#reviews');

		if (reviewsBlock) {
			onViewportEnter(
				[reviewsBlock],
				() => this.richContentReviews.init()
			);
		}
	}

	/**
	 * @returns {RichContentReviews}
	 * @private
	 */
	_createRichContentReviews() {
		return new RichContentReviews({
			'reviewsData': {
				'eventId': this.getCurrentEventId()
			},
			'getFetchContentUrl': ({eventId, imagesFirst, page}) => (
				`event/${eventId}/review/block_content/${page}/?imagesFirst=${imagesFirst}&hasRichContent=${!!$('.richContentBlock').length}`
			)
		});
	}

	initScrollspy() {
		const self = this;

		if ($('#eventPage_subnav').length) {
			new ScrollSpy(
				document.body,
				{
					'target': '#eventPage_subnav',
					'offset': 300
				}
			);
			$('#eventPage_subnav').on('click', 'li a', false);
		}

		if ($('#nav-indicatorMarkers').length) {
			new ScrollSpy(
				document.body,
				{
					'target': '#nav-indicatorMarkers',
					'offset': 300
				}
			);
			
			$('#nav-indicatorMarkers').on('click', 'a', function(ev) {
				self.scrollToTarget($($(this).attr('href')));
				ev.preventDefault();
			});
		}
	}
	
	/**
	 * @param {jQuery} obj
	 */
	scrollToTarget(obj) {
		if (!obj || !obj.length) {
			return;
		}

		const body = $('html, body');

		body.stop().animate(
			{
				'scrollTop': obj.offset().top - 150
			},
			500,
			'swing'
		);
	}

	initTracking() {
		dataLayer.push({
			'destinationId': this.getCurrentEventId(),
			'pageType'     : window.globalParams.pageType
		});

		const eventsToTrack = [
			[
				'#calendar',
				{
					'matchesButton': 'true'
				}
			],
			[
				'#club',
				{
					'clubButton': 'true'
				}
			],
			[
				'#city',
				{
					'cityButton': 'true'
				}
			],
			[
				'#seating',
				{
					'seatingButton': 'true'
				}
			],
			[
				'#reviews',
				{
					'reviewsButton': 'true'
				}
			]
		];

		eventsToTrack.forEach((eventData) => this.trackClick(eventData[0], eventData[1]));
	}

	trackClick(element, dataLayerData) {
		$(element).on('click', () => dataLayer.push(dataLayerData));
	}

	initArrangementsList() {
		if ($('#arrangementsList').length) {
			loadArrangementListMainContent({
				'beforeFilteringRequest': (filterQuery) => {
					filterQuery.shouldShowRedesignedClubPage = window.shouldShowRedesignedClubPage;
				}
			});
		}
	}

	initEvents() {
		if (window.shouldShowRedesignedClubPage) {
			this.richContentReviews.initBadge();
			
			$('details.sc_fs_faq').click(function() {
				$('details.sc_fs_faq').not(this).removeAttr('open');
			});
		}

		$(window).on('scroll', () => {
			requestAnimationFrame(() => {
				this.setSticky();
			});
		});

		$('.clubPageUniqueChange-section-trigger, .sub-nav .nav-item a').on('click', (ev) => {
			const clicked 	 = $(ev.currentTarget),
				  triggerBtn = $(clicked.attr('data-triggerbtn'));

			$('.sub-nav li a').removeClass('active');
			clicked.addClass('active');

			if (triggerBtn.length) {
				triggerBtn.trigger('click');
			} else {
				$([document.documentElement, document.body]).animate({
					'scrollTop': $(`${clicked.attr('data-href')}`).offset().top - 50
				}, DURATION / 2);
			}

			ev.preventDefault();
		});

		$('.mobile-gallery-opener').on('click', () => {
			$('.galleryWithPreview .galleryWithPreviewItem').first().trigger('click');
		});

		$('.btn.more').on('click', (ev) => {
			const $btn    = $(ev.currentTarget),
			      parent  = $btn.data('parent'),
			      $parent = $(parent),
			      method  = $btn.data('method');

			$('.content-item')
				.removeClass('open')
				.find('.btn.more')
				.data('method', 'show');

			if (method === 'show') {
				$parent.addClass('open');

				$(`${parent} .description div.row.text`).toggle(DURATION);
				$btn
					.html($btn.data('close'))
					.data('method', 'hide');

				if ($(`${parent}Title`).length) {
					setTimeout(() => {
						$([document.documentElement, document.body]).animate({
							'scrollTop': $(`${parent}Title`).offset().top - 150
						}, DURATION / 2);
					}, DURATION);
				}
			} else {
				$parent.removeClass('open');
				$(`${parent} .description div.row.text`).toggle(DURATION);
				$btn
					.html($btn.data('open'))
					.data('method', 'show');

				if ($(`${parent}Title`).length) {
					setTimeout(() => {
						$([document.documentElement, document.body]).animate({
							'scrollTop': $(`${parent}Title`).offset().top - 150
						}, DURATION / 2);
					}, DURATION);
				}
			}

			$('.content-item:not(".open")').each((i, content) => {
				const btnHTML = $(content).find('.btn.more').attr('data-open');

				$(content)
					.find('.short')
					.show()
					.end()
					.find('.full')
					.hide()
					.end()
					.find('.btn.more')
					.html(btnHTML);
			});
		});

        // SCP-3173 - TODO: remove this AB-test tracking once the it is finished
		initVBTHomepageAboveTheFoldTest('storefront_club_page_visit');
	}

	setSticky() {
		const {scrollTop} = document.documentElement,
			  headerHeight = parseInt($('header').height()),
			  subNav 	   = $('.sub-nav');

		if (scrollTop > headerHeight) {
			subNav.addClass('sticky');
		} else if (scrollTop < headerHeight) {
			subNav.removeClass('sticky');
		}
	}

	saveViewedEvent() {
		const recentlyViewed = new RecentlyViewedItems();

		recentlyViewed.saveViewedEvent(this.getCurrentEventId());
	}

	getCurrentEventId() {
		return this.params.eventId;
	}

}

export default EventPageContent;